'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useState } from 'react';
import { Image } from '@/components/client';
import { updateResponsiveDialogConfig } from '@/stores/ResponsiveDialogStore';
import { MarketReviewDetailContent, type MarketReviewItem } from './MarketReviewDetailContent';
interface PhotoReviewModalContentProps {
  photoReviews: {
    imageUrl: string;
    reviewId: string;
  }[];
  reviewItems: MarketReviewItem[];
  initialReviewId?: string;
}
export const PhotoReviewModalContent = t0 => {
  const $ = _c(14);
  const {
    photoReviews,
    reviewItems,
    initialReviewId
  } = t0;
  const [selectedReviewId, setSelectedReviewId] = useState(initialReviewId ?? null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = reviewId => {
      setSelectedReviewId(reviewId);
      updateResponsiveDialogConfig({
        modalHeader: "\uD6C4\uAE30 \uC0C1\uC138"
      });
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handlePhotoClick = t1;
  if (selectedReviewId) {
    let t2;
    if ($[1] !== selectedReviewId) {
      t2 = p => p.reviewId === selectedReviewId;
      $[1] = selectedReviewId;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    const photoIndex = photoReviews.findIndex(t2);
    let t3;
    if ($[3] !== reviewItems) {
      t3 = reviewItems.filter(_temp);
      $[3] = reviewItems;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    const photoReviewItems = t3;
    const t4 = photoIndex >= 0 ? photoIndex : 0;
    let t5;
    if ($[5] !== photoReviewItems || $[6] !== t4) {
      t5 = <MarketReviewDetailContent reviews={photoReviewItems} initialIndex={t4} />;
      $[5] = photoReviewItems;
      $[6] = t4;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    return t5;
  }
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("grid min-h-[400px] grid-cols-5 gap-8 p-20", "mobile-tablet:grid-cols-3");
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== photoReviews) {
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = (t5, index) => {
        const {
          imageUrl,
          reviewId: reviewId_0
        } = t5;
        return <button key={`${reviewId_0}-${index}`} type="button" className="relative aspect-square overflow-hidden rounded-small border border-Gray-black/5" onClick={() => handlePhotoClick(reviewId_0)}><Image src={imageUrl} alt={"\uD3EC\uD1A0\uD6C4\uAE30"} width={300} height={300} className="size-full object-cover object-center" /></button>;
      };
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t3 = photoReviews.map(t4);
    $[9] = photoReviews;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[12] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
function _temp(r) {
  return r.imageUrlList && r.imageUrlList.length > 0;
}